// src/components/sdk/components/SideMenu.tsx
import React from 'react';
import { Menu } from 'antd';
import { KeyOutlined, HistoryOutlined, CloudDownloadOutlined, FileTextOutlined } from '@ant-design/icons';

interface SideMenuProps {
    selectedKey: string;
    onMenuClick: (e: any) => void;
    t: (key: string) => string;
}

interface SideMenuState { }

export class SideMenu extends React.Component<SideMenuProps, SideMenuState> {
    constructor(props: SideMenuProps) {
        super(props);
        this.state = {};
    }

    render() {
        const { selectedKey, onMenuClick, t } = this.props;

        return (
            <Menu
                mode="inline"
                selectedKeys={[selectedKey]}
                onClick={onMenuClick}
                style={{ height: '100%', borderRight: 0 }}
            >
                <Menu.Item key="apikey" icon={<KeyOutlined />}>
                    {t('sdk.menu.apikey') || 'API密钥'}
                </Menu.Item>
                <Menu.Item key="usage" icon={<HistoryOutlined />}>
                    {t('sdk.menu.usage') || '使用记录'}
                </Menu.Item>
                <Menu.Item key="download" icon={<CloudDownloadOutlined />}>
                    {t('sdk.menu.download') || 'SDK下载'}
                </Menu.Item>
                <Menu.Item key="log" icon={<FileTextOutlined />}>
                    {t('sdk.menu.log') || '日志管理'}
                </Menu.Item>
            </Menu>
        );
    }
}

export default SideMenu;